module.exports = __webpack_public_path__ + "static/media/instagram.744e6474.svg";